export const triggerWc = () => {
	const wcEvent = new CustomEvent('wc-trigger');
	document.dispatchEvent(wcEvent);
	window.wcTriggered = true;
};
